module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('md-card', {
    staticClass: "card",
    staticStyle: {
      "margin": "1rem"
    }
  }, [_c('md-card-content', [_c('md-layout', {
    staticStyle: {
      "position": "relative !important"
    },
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticStyle: {
      "z-index": "999"
    },
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    on: {
      "click": _vm.previousFFView
    }
  }, [_vm._v("« Back")])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-center",
    staticStyle: {
      "position": "absolute"
    },
    attrs: {
      "md-flex": "100"
    }
  }, [_c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Assignment Tracking")])])], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-warning direct-chat direct-chat-warning"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Internal Chat")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    staticStyle: {
      "border": "1px solid #e7e7e7"
    }
  }, [_c('div', {
    staticClass: "direct-chat-messages",
    attrs: {
      "id": "internalChat"
    }
  }, _vm._l((_vm.internalChat), function(item, index) {
    return _c('ul', {
      key: index,
      staticStyle: {
        "padding": "0",
        "margin": "0"
      }
    }, [_c('div', {
      staticClass: "direct-chat-msg"
    }, [_c('div', {
      staticClass: "direct-chat-info clearfix"
    }, [_c('span', {
      staticClass: "direct-chat-name pull-left"
    }, [_vm._v(_vm._s(item.employeeName))]), _vm._v(" "), _c('span', {
      staticClass: "direct-chat-timestamp pull-right"
    }, [_vm._v(_vm._s(_vm._f("moment")(item.loginTime)))])]), _vm._v(" "), _c('img', {
      staticClass: "direct-chat-img",
      attrs: {
        "src": "https://image.flaticon.com/icons/svg/149/149452.svg",
        "alt": "message user image"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "direct-chat-text"
    }, [_vm._v(_vm._s(item.remarkMsg))])])])
  }))])])]), _vm._v(" "), (this.jsonObj.login != 'portLogin') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-warning direct-chat direct-chat-warning"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Client Chat")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    staticStyle: {
      "border": "1px solid #e7e7e7"
    }
  }, [_c('div', {
    staticClass: "direct-chat-messages",
    attrs: {
      "id": "your_div"
    }
  }, _vm._l((_vm.clientChat), function(item, index) {
    return _c('ul', {
      key: index,
      staticStyle: {
        "padding": "0",
        "margin": "0"
      }
    }, [_c('div', {
      staticClass: "direct-chat-msg",
      class: item.clientId == '0' ? 'right' : ''
    }, [_c('div', {
      staticClass: "direct-chat-info clearfix"
    }, [_c('span', {
      staticClass: "direct-chat-name",
      class: item.clientId == '0' ? 'pull-right' : 'pull-left'
    }, [_vm._v(_vm._s(item.clientId == '0' ? item.employeeName : item.clientName))]), _vm._v(" "), _c('span', {
      staticClass: "direct-chat-timestamp",
      class: item.clientId == '0' ? 'pull-left' : 'pull-right'
    }, [_vm._v(_vm._s(_vm._f("moment")(item.loginTime)))])]), _vm._v(" "), _c('img', {
      staticClass: "direct-chat-img",
      attrs: {
        "src": "https://image.flaticon.com/icons/svg/149/149452.svg",
        "alt": "message user image"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "direct-chat-text"
    }, [_vm._v(_vm._s(item.remarkMsg))])])])
  }))])])]) : _vm._e()]), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pr-4",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Client / Internal")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.jsonObj.login == 'portLogin',
      "option-value": "typeV",
      "option-text": "typeT",
      "list": _vm.typeList,
      "placeholder": "Select "
    },
    model: {
      value: (_vm.updateModal.msgType),
      callback: function($$v) {
        _vm.$set(_vm.updateModal, "msgType", $$v)
      },
      expression: "updateModal.msgType"
    }
  }), _vm._v(" "), (!_vm.updateModal.msgType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorDocModal.msgType))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-4",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Assignment Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "statusV",
      "option-text": "statusT",
      "list": _vm.statusList,
      "placeholder": "Select Status "
    },
    model: {
      value: (_vm.updateModal.status),
      callback: function($$v) {
        _vm.$set(_vm.updateModal, "status", $$v)
      },
      expression: "updateModal.status"
    }
  }), _vm._v(" "), (!_vm.updateModal.status) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorDocModal.status))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "itemDescription"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('b-form-textarea', {
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "remark",
      "name": "remark"
    },
    model: {
      value: (_vm.updateModal.remarkMsg),
      callback: function($$v) {
        _vm.$set(_vm.updateModal, "remarkMsg", $$v)
      },
      expression: "updateModal.remarkMsg"
    }
  }), _vm._v(" "), (!_vm.updateModal.remarkMsg) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorDocModal.remarkMsg))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "justify-content-center mt-2",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    attrs: {
      "id": "addButtonLoader1"
    },
    on: {
      "click": _vm.sendUpdate
    }
  }, [_vm._v("Send")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a75917e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/clientDashboard/internalAssignStatus.vue
// module id = 2380
// module chunks = 0